import Toast from "components/cms/Toast";
import ProductsStack from "components/cms/ProductsStack";
import useCmsPage from "hooks/useCmsPage";

export default function ProductCmsPage({
  label,
  heading,
  description,
  idPrefix,
  load,
  create,
  update,
  empty,
  prepare,
}) {
  const {
    form,
    setField,
    frMap,
    exists,
    loading,
    toast,
    setToast,
    save,
    saveSection,
    savingSection,
    isSectionDirty,
  } = useCmsPage({
    load,
    create,
    update,
    empty,
    mapResponse: (res) => res.data?.data,
    prepare,
  });

  const saveProducts = (sectionId, keys) => {
    if (!exists) {
      save();
      return;
    }
    saveSection(sectionId, keys);
  };

  if (loading) {
    return <p className="mt-5 text-gray-600">Loading {label}…</p>;
  }

  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={() => setToast(null)} />
      {!exists ? (
        <p className="mb-3 text-sm text-gray-500">
          {label} is not saved yet. Fill the sections and click Save to create
          this page.
        </p>
      ) : null}
      <ProductsStack
        heading={heading}
        description={description}
        idPrefix={idPrefix}
        form={form}
        setField={setField}
        frMap={frMap}
        exists={exists}
        saveProducts={saveProducts}
        savingSection={savingSection}
        isSectionDirty={isSectionDirty}
      />
    </div>
  );
}
